export default __webpack_public_path__ + "static/media/concrete_cage.fa0078b6.svg";